<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container-fluid">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Income Statement Summary Reports
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :title="'INCOME STATEMENT'" :form="form" @filterAction="filterAction"
										:filter="filter"></report-filter>
									<b-button @click="printPDF" class="me-2 btn-sm akkurate-green-btn akkurate-small"
										title="Print"><font-awesome-icon :icon="['fas', 'print']" /></b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download"><font-awesome-icon :icon="['fas', 'download']" /></b-button>
								</div>
							</div>
							<div class="row">
								<div class="col-6"></div>
								<!-- <div class="col-6 text-end">
                    <b-button @click="printPDF" class="me-2 btn-sm akkurate-green-btn akkurate-small" title="Print"><font-awesome-icon :icon="['fas', 'print']"/></b-button>
                    <b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small" title="Download"><font-awesome-icon :icon="['fas', 'download']"/></b-button>
                  </div> -->
							</div>
						</div>
						<div class="card-body" ref="pdfContent">
							<div class="row mx-1">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'INCOME STATEMENT SUMMARY'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row mx-1">
								<div class="col-12 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span class="mt-2">Reporting Date:
										<strong>{{ form.end_date }}</strong>
									</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<!-- <div v-else id="balance-sheet" class="row">
                
              </div> -->
							<div v-else id="balance-sheet" class="row mx-1">
								<div class="col-12 col-md-12 px-0 trans_details">
									<b-table-simple responsive outlined>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green" colspan="6"><span>INCOME
														SUMMARY</span></b-th>
											</b-tr>
											<b-tr>
												<b-th class=""><span>GL Code</span></b-th>
												<b-th class=""><span>GL Name</span></b-th>
												<b-th class=""><span>Income Current
														Month</span></b-th>
												<b-th class=""><span>Income Year to
														Date</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr v-for="(
													income, incomeIndex
												) in incomes" :key="'income-' + incomeIndex" class="list-item">
												<b-td class="py-0 px-2">{{
													income.code
												}}</b-td>
												<b-td class="py-0 px-2">{{
													income.name
												}}</b-td>
												<b-td class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															Number(
																income.total_monthly_amount
															).toFixed(2)
														)
													}}
												</b-td>
												<b-td class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															Number(
																income.total_yearly_amount
															).toFixed(2)
														)
													}}
												</b-td>
											</b-tr>
											<b-tr>
												<b-th> Total Income </b-th>
												<b-th class="py-0 px-2"></b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															grant_monthly_total_incomes
																? grant_monthly_total_incomes.toFixed(
																	2
																)
																: 0
														)
													}}
												</b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															grant_yearly_total_incomes
																? grant_yearly_total_incomes.toFixed(
																	2
																)
																: 0
														)
													}}
												</b-th>
											</b-tr>
										</b-tbody>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green" colspan="6"><span>EXPENSES
														SUMMARY</span></b-th>
											</b-tr>
											<b-tr>
												<b-th class=""><span>GL Code</span></b-th>
												<b-th class=""><span>GL Name</span></b-th>
												<b-th class=""><span>Expense Current
														Month</span></b-th>
												<b-th class=""><span>Expense Year to
														Date</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr v-for="(
													expense, expenseIndex
												) in expenses" :key="'expense - ' + expenseIndex
													" class="list-item">
												<b-td class="py-0 px-2">{{
													expense.code
												}}</b-td>
												<b-td class="py-0 px-2">{{
													expense.name
												}}</b-td>
												<b-td class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															Number(
																expense.total_monthly_amount
															).toFixed(2)
														)
													}}
												</b-td>
												<b-td class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															Number(
																expense.total_yearly_amount
															).toFixed(2)
														)
													}}
												</b-td>
											</b-tr>
											<b-tr>
												<b-th> Total Expenses </b-th>
												<b-th class="py-0 px-2"></b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															grant_monthly_total_expenses
																? grant_monthly_total_expenses.toFixed(
																	2
																)
																: 0
														)
													}}
												</b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															grant_yearly_total_expenses
																? grant_yearly_total_expenses.toFixed(
																	2
																)
																: 0
														)
													}}
												</b-th>
											</b-tr>
										</b-tbody>
										<b-tfoot>
											<!-- <b-tr>
                        <b-td class="fw-bold">
                          Profit / Loss
                        </b-td>
                        <b-th class="py-0 px-2"></b-th>
                        <b-td class="fw-bold"> {{ institution?.currency_code }}  {{ displayNumber(Number(grant_monthly_total_expenses).toFixed(2)) }}</b-td>
                        
                      </b-tr> -->
											<b-tr>
												<b-th class="py-0 px-2">
													Profit / Loss (GHS)</b-th>
												<b-th class="py-0 px-2"></b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															profit_or_loss_monthly
																? Math.abs(
																	profit_or_loss_monthly
																).toFixed(2)
																: 0
														)
													}}
													<span v-if="
														profit_or_loss_monthly <
														0
													">(Loss)</span>
													<span v-else>(Profit)</span>
												</b-th>
												<b-th class="py-0 px-2">
													{{
														institution?.currency_code
													}}
													{{
														displayNumber(
															profit_or_loss_yearly
																? Math.abs(
																	profit_or_loss_yearly
																).toFixed(2)
																: 0
														)
													}}
													<span v-if="
														profit_or_loss_yearly <
														0
													">(Loss)</span>
													<span v-else>(Profit)</span>
												</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import ReportFilter from "../form/ReportFilter.vue";
import html2pdf from "html2pdf.js";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				// start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().substr(0, 10),
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status: [],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: true,
				coa: false,
				voucher_status: false,
				start_date: false,
				end_date: true,
				loan_status: false,
			},
			incomes: [],
			expenses: [],
			profit_or_loss: 0,
			search: "Search",
			grant_total_expenses: 0,
			grant_total_incomes: 0,
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			numbers_options: [10, 50, 100, 500],
			isLoadingInstitution: false,
			institution: "",
			// start_date: "",
			end_date: "",
			grant_monthly_total_incomes: 0,
			grant_yearly_total_incomes: 0,
			grant_monthly_total_expenses: 0,
			grant_yearly_total_expenses: 0,
			grant_total_expenses: 0,
			profit_or_loss_monthly: 0,
			profit_or_loss_yearly: 0,
			fields: [
				{
					key: "account_number",
					label: "Account Number",
				},
				{
					key: "customer_name",
					label: "Customer Name",
				},
				{
					key: "amount",
					label: "Amount",
				},
				{
					key: "min_balance",
					label: "Minimum Balance",
				},
				{
					key: "total",
					label: "Total",
				},
			],
			perPage: 20,
			currentPage: 1,
			items: [],
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].loan_balance;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].saving_balance;
			}

			return total;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		}
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
		this.getProductDropdown();
	},
	methods: {
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					// console.log(response.data);
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
					// this.form.product_options = response.data.products;
					// this.form.coa_options = response.data.coa_subheads;
				})
				.catch((error) => {
					// console.log(error);
					this.isBusy = false;
					this.search = "Search";
				});
		},
		async getBalanceSheets() {
			var branches = [];
			if (this.form.branches != []) {
				branches = this.form.branches.map((index) => index.id) ?? [];
			}
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post("/reports/financials/income-statement", {
				// startDate: this.form.start_date,
				endDate: this.form.end_date,
				terms: this.form.terms,
				branches: branches,
			})
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					// var res = response.data?.data;
					var res = response.data;
					// console.log(res);
					this.incomes = res.incomes;
					this.expenses = res.expenses;
					this.grant_monthly_total_incomes = res.grant_monthly_total_incomes;
					this.grant_yearly_total_incomes = res.grant_yearly_total_incomes;
					this.grant_monthly_total_expenses = res.grant_monthly_total_expenses;
					this.grant_yearly_total_expenses = res.grant_yearly_total_expenses;
					this.grant_total_expenses = res.grant_total_expenses;
					this.profit_or_loss_monthly = this.grant_monthly_total_incomes - this.grant_monthly_total_expenses;
					this.profit_or_loss_yearly = this.grant_yearly_total_incomes - this.grant_yearly_total_expenses;
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		filterTable() {
			this.getReceiptListing();
		},
		changePerPageNumber(data) {
			this.perPage = data;
			this.getReceiptListing();
		},
		// async generateExcel() {
		// 	const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
		// 	const imageUrl = "/default_logo.png"; // Path to your image file

		// 	// Institution details
		// 	const institutionName = this.institution.name;
		// 	const institutionMotto = this.institution.motto;
		// 	const institutionAddress = this.institution.address;
		// 	const institutionPhone = this.institution.telephone;
		// 	const institutionEmail = this.institution.email;
		// 	const date =
		// 		"FROM: " +
		// 		this.form.start_date +
		// 		" TO: " +
		// 		this.form.end_date;
		// 	const terms = "TERMS:  " + this.form.terms;

		// 	try {
		// 		// Fetch the Excel file from the public URL
		// 		// Fetch the Excel file from the public URL
		// 		const response = await fetch(fileUrl);
		// 		if (!response.ok) {
		// 			throw new Error(
		// 				`Network response was not ok: ${response.statusText}`
		// 			);
		// 		}
		// 		const arrayBuffer = await response.arrayBuffer();

		// 		// Load the file into ExcelJS
		// 		const wb = new ExcelJS.Workbook();
		// 		await wb.xlsx.load(arrayBuffer);

		// 		// Access the first sheet
		// 		const ws = wb.getWorksheet(1); // Get the first worksheet

		// 		// Add Image to the top of the sheet
		// 		const imageResponse = await fetch(imageUrl);
		// 		const imageBuffer = await imageResponse.arrayBuffer();
		// 		const imageId = wb.addImage({
		// 			buffer: imageBuffer,
		// 			extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
		// 		});

		// 		// Insert the image at the top-left corner (row 1, column 1)
		// 		ws.addImage(imageId, {
		// 			tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
		// 			ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
		// 		});

		// 		// Insert institution details next to the image (starting at row 1, col 5)
		// 		const institutionDetailsStartCol = 5; // Column where text starts after image
		// 		const institutionDetailsRow = 1; // Row for institution details

		// 		// Add the institution name, address, and phone number
		// 		ws.getCell(`L${institutionDetailsRow}`).value =
		// 			institutionName;
		// 		ws.getCell(`L${institutionDetailsRow}`).font = {
		// 			bold: true,
		// 			size: 14,
		// 		}; // Bold and bigger font for name

		// 		ws.getCell(`L${institutionDetailsRow + 1}`).value =
		// 			institutionAddress;
		// 		ws.getCell(`L${institutionDetailsRow + 1}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for address

		// 		ws.getCell(`L${institutionDetailsRow + 2}`).value =
		// 			institutionMotto;
		// 		ws.getCell(`L${institutionDetailsRow + 2}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 3}`).value =
		// 			institutionPhone;
		// 		ws.getCell(`L${institutionDetailsRow + 3}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 4}`).value =
		// 			institutionEmail;
		// 		ws.getCell(`L${institutionDetailsRow + 4}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
		// 		ws.getCell(`L${institutionDetailsRow + 6}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
		// 		ws.getCell(`L${institutionDetailsRow + 7}`).font = {
		// 			size: 12,
		// 		}; // Regular font size for phone

		// 		// Optionally adjust the column width if the text is long
		// 		ws.getColumn("K").width = 50; // Adjust the width of column D (if necessary)

		// 		// Define header row
		// 		const header1 = ["INCOME SUMMARY"];
		// 		const header2 = ["EXPENSES SUMMARY"];

		// 		// Add header row starting from row 13
		// 		const startingRow = 13;
		// 		let headerRow = ws.getRow(startingRow);
		// 		headerRow.values = header1;
		// 		headerRow.font = { bold: true, underline: "single" };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		// Add income data rows (adjusted for your structure)
		// 		let currentRow = startingRow + 1;

		// 		const subHeader1 = [
		// 			"GL Code",
		// 			"GL Name",
		// 			"Income Current Month",
		// 			"Income Year to Date",
		// 		];

		// 		headerRow = ws.getRow(currentRow);
		// 		headerRow.values = subHeader1;
		// 		headerRow.font = { bold: true };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		currentRow++;

		// 		this.incomes.forEach((item) => {
		// 			const row = ws.getRow(currentRow);
		// 			row.values = [
		// 				item.code,
		// 				item.name, // Assuming each income item has a `name`
		// 				item.total_monthly_amount, // Assuming `total_monthly_amount` exists
		// 				item.total_yearly_amount, // Assuming `total_yearly_amount` exists
		// 			];
		// 			row.commit();
		// 			currentRow++;
		// 		});

		// 		currentRow++;
		// 		headerRow = ws.getRow(currentRow);
		// 		headerRow.values = header2;
		// 		headerRow.font = { bold: true, underline: "single" };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		// Add income data rows (adjusted for your structure)
		// 		currentRow++;

		// 		const subHeader2 = [
		// 			"GL Code",
		// 			"GL Name",
		// 			"Expense Current Month",
		// 			"Expense Year to Date",
		// 		];

		// 		headerRow = ws.getRow(currentRow);
		// 		headerRow.values = subHeader2;
		// 		headerRow.font = { bold: true };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		currentRow++;

		// 		// Add expense data rows (adjusted for your structure)
		// 		this.expenses.forEach((item) => {
		// 			const row = ws.getRow(currentRow);
		// 			row.values = [
		// 				item.code,
		// 				item.name, // Expense Name
		// 				item.total_monthly_amount, // Expense Monthly Amount
		// 				item.total_yearly_amount, // Expense Yearly Amount
		// 			];
		// 			row.commit();
		// 			currentRow++;
		// 		});

		// 		// Write the file buffer and create a Blob for download
		// 		const buffer = await wb.xlsx.writeBuffer();
		// 		const blob = new Blob([buffer], {
		// 			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		// 		});

		// 		// Create a download link and simulate a click to download the file
		// 		const link = document.createElement("a");
		// 		link.href = URL.createObjectURL(blob);
		// 		link.download = `Income_and_Expenses_Summary_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
		// 		document.body.appendChild(link);
		// 		link.click();
		// 		document.body.removeChild(link);
		// 	} catch (err) {
		// 		console.error(
		// 			"Error fetching, modifying, or downloading the Excel file:",
		// 			err.message
		// 		);
		// 	}
		// },
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"AS AT: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png",
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 },
					ext: { width: 300, height: 200 },
				});

				// Insert institution details next to the image
				const institutionDetailsRow = 1;

				// Add the institution name, address, and phone number
				ws.getCell(`L${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`L${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				};

				ws.getCell(`L${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`L${institutionDetailsRow + 1}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`L${institutionDetailsRow + 2}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`L${institutionDetailsRow + 3}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`L${institutionDetailsRow + 4}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`L${institutionDetailsRow + 6}`).font = {
					size: 12,
				};

				ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`L${institutionDetailsRow + 7}`).font = {
					size: 12,
				};

				// Adjust column width
				ws.getColumn("K").width = 50;

				// Add headers and data for INCOME SUMMARY
				const incomeStartingRow = 13;
				let currentRow = incomeStartingRow;

				// INCOME SUMMARY header
				let headerRow = ws.getRow(currentRow);
				headerRow.values = ["INCOME SUMMARY"];
				headerRow.font = { bold: true, underline: "single" };
				headerRow.commit();
				currentRow++;

				// Income sub-headers
				const incomeSubHeaders = [
					"GL Code",
					"GL Name",
					"Income Current Month",
					"Income Year to Date",
				];
				headerRow = ws.getRow(currentRow);
				headerRow.values = incomeSubHeaders;
				headerRow.font = { bold: true };
				headerRow.commit();
				currentRow++;

				// Add income data
				this.incomes.forEach((item) => {
					const row = ws.getRow(currentRow);
					row.values = [
						item.code,
						item.name,
						Number(item.total_monthly_amount).toFixed(2),
						Number(item.total_yearly_amount).toFixed(2),
					];
					row.commit();
					currentRow++;
				});

				// Add total income row
				const totalIncomeRow = ws.getRow(currentRow);
				totalIncomeRow.values = [
					"Total Income",
					"",
					Number(this.grant_monthly_total_incomes).toFixed(2),
					Number(this.grant_yearly_total_incomes).toFixed(2),
				];
				totalIncomeRow.font = { bold: true };
				totalIncomeRow.commit();
				currentRow += 2;

				// EXPENSES SUMMARY header
				headerRow = ws.getRow(currentRow);
				headerRow.values = ["EXPENSES SUMMARY"];
				headerRow.font = { bold: true, underline: "single" };
				headerRow.commit();
				currentRow++;

				// Expense sub-headers
				const expenseSubHeaders = [
					"GL Code",
					"GL Name",
					"Expense Current Month",
					"Expense Year to Date",
				];
				headerRow = ws.getRow(currentRow);
				headerRow.values = expenseSubHeaders;
				headerRow.font = { bold: true };
				headerRow.commit();
				currentRow++;

				// Add expense data
				this.expenses.forEach((item) => {
					const row = ws.getRow(currentRow);
					row.values = [
						item.code,
						item.name,
						Number(item.total_monthly_amount).toFixed(2),
						Number(item.total_yearly_amount).toFixed(2),
					];
					row.commit();
					currentRow++;
				});

				// Add total expenses row
				const totalExpensesRow = ws.getRow(currentRow);
				totalExpensesRow.values = [
					"Total Expenses",
					"",
					Number(this.grant_monthly_total_expenses).toFixed(2),
					Number(this.grant_yearly_total_expenses).toFixed(2),
				];
				totalExpensesRow.font = { bold: true };
				totalExpensesRow.commit();
				currentRow += 2;

				// Add profit/loss row
				const profitLossRow = ws.getRow(currentRow);
				const monthlyProfitLoss = this.profit_or_loss_monthly;
				const yearlyProfitLoss = this.profit_or_loss_yearly;
				profitLossRow.values = [
					"Profit / (Loss)",
					"",
					Number(Math.abs(monthlyProfitLoss)).toFixed(2) + (monthlyProfitLoss < 0 ? " (Loss)" : " (Profit)"),
					Number(Math.abs(yearlyProfitLoss)).toFixed(2) + (yearlyProfitLoss < 0 ? " (Loss)" : " (Profit)"),
				];
				profitLossRow.font = { bold: true };
				profitLossRow.commit();

				// Write the file buffer and create a Blob for download
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `Income_and_Expenses_Summary_as_at_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		filterAction() {
			this.getBalanceSheets();
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},

		filterAction() {
			this.getBalanceSheets();
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
	},
};
</script>
